import { bind as bindApiService } from '@monofe/apiservice';
import { bind as bindAppCommon } from '@monofe/app-common';
import { bind as bindAppState } from '@monofe/appstate';
import { buildBinderListings } from '@monofe/di';
import { bind as bindUIWorkspace } from '@monofe/ui-workspace';
import { bind as bindUtil } from '@monofe/util';
import { bind as bindWorker } from '@monofe/worker';
import { TYPES } from '@monofe/worker/util';
import bindConfig from './config';
import { default as bindTourDataResolver } from './tourDataResolver.bind';

function all() {
  /* SettingsStorage uses IDB, which isn't available in NodeJS */
  const banishList = [TYPES.ISettingsStorage];
  const bindables = [buildBinderListings([bindTourDataResolver], Symbol.for('pwa')), bindUtil, bindApiService, bindAppState, bindUIWorkspace, bindConfig, bindWorker, bindAppCommon].flatMap(listing => listing.allBinders()).filter(binder => !banishList.includes(binder.id));
  return Promise.resolve(bindables);
}

export default Object.freeze({
  all
});